import { palette, pxToRem, typography } from '@fluentsms/agentnet-web-components';
import createTypography from '@material-ui/core/styles/createTypography';

const fontFamily = typography.fontFamily || ['Inter', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(',');

const kbTypography = createTypography(palette, {
  fontFamily,
  h1: {
    fontFamily,
    fontSize: pxToRem(32),
    fontWeight: 600,
    letterSpacing: 0.64,
    lineHeight: '130%',
  },
  h2: {
    fontFamily,
    fontSize: pxToRem(24),
    fontWeight: 600,
    letterSpacing: 0.24,
    lineHeight: '130%',
  },
  h3: {
    fontFamily,
    fontSize: pxToRem(20),
    fontWeight: 500,
    lineHeight: '130%',
  },
  h4: {
    fontFamily,
    fontSize: pxToRem(18),
    fontWeight: 500,
    lineHeight: '130%',
  },
  h5: {
    fontFamily,
    fontWeight: 500,
    lineHeight: '130%',
    fontSize: pxToRem(16),
  },
  h6: {
    fontFamily,
    fontWeight: 500,
    lineHeight: '130%',
    fontSize: pxToRem(16),
  },
  body1: {
    fontFamily,
    fontSize: pxToRem(16),
    fontWeight: 400,
    lineHeight: '150%',
  },
  body2: {
    fontFamily,
    fontSize: pxToRem(14),
    fontWeight: 400,
    lineHeight: 'normal',
  },
  caption: {
    fontFamily,
    fontSize: pxToRem(14),
    fontWeight: 400,
    lineHeight: '140%',
  },
  overline: {
    fontFamily,
    fontSize: pxToRem(18),
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '150%',
    textTransform: 'none',
  },
});

export default kbTypography;
